// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"692":"view","768":"page"}[chunkId] || chunkId) + "." + {"692":"d77ed013","768":"794f696e","897":"48744c68"}[chunkId] + ".js";
};